/**
 * shared/lib/viewport — утилиты для работы с размерами viewport.
 * Чистые функции без зависимостей от доменных слоёв.
 */

/** Возвращает true, если текущая ширина экрана >= 768px (breakpoint md). */
export function isMdViewport(): boolean {
  if (typeof window === 'undefined') return true;
  return window.matchMedia('(min-width: 768px)').matches;
}
